









import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	PRACOVNIK_ID: number;
	PRIJMENI: string;
	OSOBNI_CIS: string;
	JMENO: string;
	PROVOZOVNA_ID: number;
	STREDNAKL_OZN: number;
	X_STREDNAKL_OZN: string;
	STRNAKLTYP_OZN: string;
	X_PROVOZOVNA_ID: string;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'PRACOVNIK_ID' },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'PRACOVNIK_ID',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				osobniCis: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.PRACOVNIK_ID,
				text: data.PRIJMENI,
				osobniCis: data.OSOBNI_CIS,
				jmeno: data.JMENO,
				provozovnaId: data.PROVOZOVNA_ID,
				strednaklOzn: data.STREDNAKL_OZN,
				strednaklOznText: data.X_STREDNAKL_OZN,
				strnakltypOzn: data.STRNAKLTYP_OZN,
				provozovnaIdText: data.X_PROVOZOVNA_ID,
			};
		},
	},
});
